import React from "react";
import { Link } from "react-router-dom";
import { Sun, VideoCamera, Lightning, BatteryCharging, Browsers, Phone, MapPin, Globe } from "@phosphor-icons/react";
import { COMPANY } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-5 bg-white p-3 inline-flex max-w-fit rounded-sm">
              <img src={COMPANY.logo} alt="TamilBTC Technologies" className="h-16 w-auto object-contain" />
            </div>
            <p className="text-sm leading-relaxed text-slate-400 max-w-sm">
              {COMPANY.tagline}. Trusted by 1000+ homes and businesses across Tamil Nadu.
            </p>
            <p className="mt-6 font-heading text-amber-400 font-semibold text-base">
              {COMPANY.slogan}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="label-eyebrow text-slate-500 mb-4">Solutions</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/solar" className="hover:text-white flex items-center gap-2"><Sun size={14} weight="duotone" className="text-amber-400" /> Solar Energy</Link></li>
              <li><Link to="/cctv" className="hover:text-white flex items-center gap-2"><VideoCamera size={14} weight="duotone" className="text-slate-300" /> Security</Link></li>
              <li><Link to="/ev" className="hover:text-white flex items-center gap-2"><Lightning size={14} weight="duotone" className="text-emerald-400" /> Electric Mobility</Link></li>
              <li><Link to="/solar" className="hover:text-white flex items-center gap-2"><BatteryCharging size={14} weight="duotone" className="text-blue-400" /> Power Backup</Link></li>
              <li><Link to="/contact" className="hover:text-white flex items-center gap-2"><Browsers size={14} weight="duotone" className="text-violet-400" /> Digital Infra</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-eyebrow text-slate-500 mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex gap-2"><MapPin size={16} weight="duotone" className="mt-0.5 shrink-0 text-amber-400" />
                <span>{COMPANY.address.line1}, {COMPANY.address.line2}, {COMPANY.address.city} – {COMPANY.address.pincode}</span>
              </li>
              <li className="flex gap-2"><Phone size={16} weight="duotone" className="text-emerald-400" />
                <a href={`tel:${COMPANY.phone}`} className="hover:text-white">{COMPANY.phoneDisplay}</a>
              </li>
              <li className="flex gap-2"><Globe size={16} weight="duotone" className="text-blue-400" />
                <span>{COMPANY.website}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </div>
          <div className="text-xs text-slate-500">
            Founded by {COMPANY.founder} • Tamil Nadu, India 🇮🇳
          </div>
        </div>
      </div>
    </footer>
  );
}
